module.exports = __webpack_public_path__ + "static/media/pack-alphaburn.c00dfe08.png";